export default __webpack_public_path__ + "static/media/discout_with_percent.9b6824de.svg";